import styled from 'styled-components';

export const Wrapper = styled.li`
  width: 100%;
  height: 70px;
  display: flex;
  column-gap: 10px;
  align-items: center;
  margin: 0 10px;
  text-decoration: none;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
